/*
 * JoMuh Verpackungseinheit (VE) / Staffelmengen-Erzwingung.
 * Ergaenzt Horizons quantity-selector minimal-invasiv:
 *  - Plus/Minus springen bereits per NATIVEM step-Attribut in VE-Schritten
 *    (step wird serverseitig in snippets/quantity-selector.liquid gesetzt,
 *     Horizons updateQuantity() liest quantityInput.step -> kein JS noetig).
 *  - Hier: (A) Blur-Rundung auf naechstes gueltiges Vielfaches (statt nur reportValidity)
 *          (B) Warenkorb-Snapping bei nicht-VE-Mengen (z.B. Quick-Add von 1 Stueck).
 * VE-Quelle steckt als data-jomuh-ve am Input (aus dem Metafeld gerendert).
 *
 * ponytail: rein client-/theme-seitige Durchsetzung. Eine UNUMGEHBARE Durchsetzung
 * (gegen direkte /cart/add.js-API-Aufrufe) braucht eine Shopify Cart/Checkout
 * Validation Function, die separat deployt wird -- NICHT Teil dieser Datei.
 */
(function () {
  if (window.__jomuhVePatched) return;
  window.__jomuhVePatched = true;

  // Rundet q auf das naechste gueltige Vielfache >= min (aufrunden Richtung naechste VE).
  function alignUp(q, min, step) {
    if (step <= 1) return q;
    if (q < min) return min;
    var rem = (q - min) % step;
    return rem === 0 ? q : q + (step - rem);
  }

  // Konsolen-Selbstcheck (Konvention wie jomuhLieferCheck): jomuhVeCheck()
  window.jomuhVeCheck = function () {
    function eq(a, b, m) {
      if (a !== b) throw new Error('jomuh VE check FAIL: ' + m + ' -> ' + a + ' != ' + b);
    }
    eq(alignUp(1, 12, 12), 12, '1->12');
    eq(alignUp(12, 12, 12), 12, '12->12');
    eq(alignUp(13, 12, 12), 24, '13->24');
    eq(alignUp(25, 12, 12), 36, '25->36');
    eq(alignUp(13, 6, 12), 18, 'min6 step12 13->18');
    eq(alignUp(7, 6, 12), 18, 'min6 step12 7->18');
    eq(alignUp(6, 6, 12), 6, 'min6 6->6');
    eq(alignUp(5, 12, 12), 12, 'unter min ->12');
    eq(alignUp(5, 1, 1), 5, 've1 unveraendert');
    console.log('jomuh VE alignUp ok (9 Faelle)');
    return true;
  };

  // (A) Blur-Rundung: setQuantity der Basis-Component patchen, sodass eine krumme
  // Eingabe AUFGERUNDET wird, bevor die Original-Logik laeuft (die sonst nur
  // reportValidity() zeigt und den Wert krumm laesst). Der Cart-Selector erbt
  // setQuantity ueber die Prototypkette -> PDP und Warenkorb sind beide abgedeckt.
  customElements.whenDefined('quantity-selector-component').then(function () {
    var proto = customElements.get('quantity-selector-component').prototype;
    if (proto.__jomuhSetQtyPatched) return;
    proto.__jomuhSetQtyPatched = true;
    var orig = proto.setQuantity;
    proto.setQuantity = function (event) {
      try {
        var input = this.refs && this.refs.quantityInput;
        if (input) {
          var step = parseInt(input.step, 10) || 1;
          if (step > 1) {
            var min = parseInt(input.min, 10) || step;
            var aligned = alignUp(parseInt(input.value, 10) || 0, min, step);
            input.value = String(aligned); // event.target ist derselbe Input
          }
        }
      } catch (e) {
        /* nie den nativen Handler blockieren */
      }
      return orig.call(this, event);
    };
  });

  // (B) Warenkorb-Snapping: nicht-VE-Mengen (Quick-Add von 1, per API eingeschleuste
  // Posten, Altbestand) ueber Horizons EIGENEN Update-Pfad korrigieren.
  // cart-items-component lauscht auf 'quantity-selector:update' (event.target muss
  // INNERHALB der Component liegen) und macht /cart/change.js + Section-Morph selbst.
  // Wir setzen NICHT auf ein einzelnes rAF nach cart:update auf -- der Section-Morph
  // laeuft ASYNCHRON und waere dann noch nicht angewendet. Stattdessen ein
  // MutationObserver je cart-items-component: er feuert GENAU dann, wenn der Morph
  // (die neuen Zeilen) im DOM landet -> race-frei, kein Zeit-Polling.
  // ponytail: eine Zeile pro Scan; der Observer feuert nach jedem Morph erneut und
  // arbeitet so weitere krumme Zeilen ab. Konvergiert, weil das reine Setzen von
  // input.value KEINE Attribut-Mutation ist (loest den Observer nicht aus) und der
  // Vergleich aligned!==q idempotent ist.
  function scanCart() {
    var inputs = document.querySelectorAll('cart-quantity-selector-component input[data-jomuh-ve]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var ve = parseInt(input.getAttribute('data-jomuh-ve'), 10) || 1;
      if (ve <= 1) continue;
      var min = parseInt(input.min, 10) || ve;
      var line = parseInt(input.getAttribute('data-cart-line'), 10);
      var q = parseInt(input.value, 10) || 0;
      if (!line || q <= 0) continue; // 0 = Zeile wird gerade entfernt
      var aligned = alignUp(q, min, ve);
      if (aligned !== q) {
        input.value = String(aligned);
        input.dispatchEvent(new CustomEvent('quantity-selector:update', {
          bubbles: true,
          detail: { quantity: aligned, cartLine: line }
        }));
        return;
      }
    }
  }

  var scanScheduled = false;
  function scheduleScan() {
    if (scanScheduled) return;
    scanScheduled = true;
    setTimeout(function () {
      scanScheduled = false;
      scanCart();
    }, 120);
  }

  function observeCart() {
    var comps = document.querySelectorAll('cart-items-component');
    for (var i = 0; i < comps.length; i++) {
      var c = comps[i];
      if (c.__jomuhVeObserved) continue;
      c.__jomuhVeObserved = true;
      new MutationObserver(scheduleScan).observe(c, { childList: true, subtree: true });
    }
  }

  function boot() {
    observeCart();
    scheduleScan();
  }

  // cart:update kann NEUE cart-items-components bringen (Drawer-Erstrender) -> neu beobachten.
  document.addEventListener('cart:update', boot);
  // Erststart: sobald die Component-Klasse definiert ist (Instanzen upgegradet + Listener haengt)
  // sowie nach window load (deckt einen etwaigen Post-Load-Rerender der Cart-Section ab).
  customElements.whenDefined('cart-items-component').then(boot);
  window.addEventListener('load', boot);
})();
